// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('customerDirectory', {
    parent: 'main',
    url: '/customers/all',
    views: {
      'main-content': {
        controller: 'CustomerDirectoryController as vm',
        templateUrl: 'main/customerDirectory/customerDirectory.tpl.html',
      },
    },
    data: { pageTitle: 'Brands' },
  });
};

class CustomerDirectoryController {
  constructor() {
    'ngInject';
  }
}

angular
  .module('main.customerDirectory', [])
  .config(config)
  .controller('CustomerDirectoryController', CustomerDirectoryController);
